import { render, staticRenderFns } from "./AnnotationSidebar.vue?vue&type=template&id=7ef2f73e&"
import script from "./AnnotationSidebar.vue?vue&type=script&lang=js&"
export * from "./AnnotationSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports